var map = {
	"./en/1-6/tit_6.png": 27753,
	"./fi/1-6/tit_6.png": 60395,
	"./in/1-6/tit_6.png": 3469,
	"./th/1-6/tit_6.png": 98596,
	"./tw/1-6/tit_6.png": 18039,
	"./zh/1-6/tit_6.png": 7846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70191;